// extracted by mini-css-extract-plugin
export default {"description":"changePeriod_description__0kEYr","content":"changePeriod_content__KLR15","contentItem":"changePeriod_contentItem__m+zak","mt12":"changePeriod_mt12__YlZSa"};